module.exports = __webpack_public_path__ + "jdshop.6c845fa9.png";